// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"361":"78df7f207f432a22062f","3093":"edce189a8b15f2006fdc","3180":"330ecf1b926554b54221"}[chunkId] + ".css";
};